// @ts-nocheck
/* eslint-disable */
export const bookmarkRemoveIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor"><path d="M850-695H610v-60h240v60ZM200-120v-665q0-24 18-42t42-18h290v60H260v574l220-93 220 93v-334h60v425L480-240 200-120Zm60-665h290-290Z"/></svg>`,
    name: 'bookmark-remove' as const
};